<template>
  <div>
     <span v-for="ch in thisq.choices"><bdi v-html="ch.text"></bdi>
        <select v-if="ch.alternatives.length > 0" size="1" v-model="ch.selected" v-on:change="finished" :style="{backgroundColor: (showfinal ? (ch.alternatives[ch.selected].correct ? '#bde273' : '#fde3e8') : 'white'), marginLeft: '8px', marginRight: '8px' }">
           <option v-for="(alt,ix) in ch.alternatives" :value="ix" :style="{backgroundColor: (showfinal ? (alt.correct ? '#bde273' : '#fde3e8') : 'white') }">{{alt.text}}</option>
        </select>
     </span>
  </div>
</template>

<script>

   export default {

      name: 'sab',
      
      props: {
        thisq: Object,
        tryonce: Boolean,
        record: Boolean,
        enbloc: Boolean,
        showscore: Boolean,
        token: String
      },

      data: function() {
        return ({
	   showfinal: false
        })
      },

   
      methods: {
         finished: function() {
	   let stat = true
	   for(let c of this.thisq.choices) {
	      if ((c.alternatives.length > 0) && (c.selected == null)) {
	        stat = false
	      }
	   }
	   this.showfinal = stat
	 }
      }
   }

</script>
